import axios from 'axios';

const BASE_URL = 'https://cliqueiachei.com.br/json-config';

const api = axios.create({
  baseURL: BASE_URL,
});

export const APIJsonConfigs = {
  async fetchMenuWebMessages() {
    const response = await api.get<{ messages: MenuWebMessage[] }>('/mensagens-cardapio.json');
    return response.data;
  },
};

export type MenuWebMessage = {
  title: string;
  description: string;
};

type Variables = {
  estabelecimento: string;
};

export const MenuWebMessageParser = {
  parse(message: MenuWebMessage, variables: Variables): MenuWebMessage {
    const expressionsReplaceFunctions = Object.entries(variables).map(([variable, value]) => {
      return (str: string) => str.replaceAll(`\${${variable}}`, value);
    });

    let titleParsed = message.title;
    for (const replaceVariable of expressionsReplaceFunctions) {
      titleParsed = replaceVariable(titleParsed);
    }

    let descriptionParsed = message.description;
    for (const replaceVariable of expressionsReplaceFunctions) {
      descriptionParsed = replaceVariable(descriptionParsed);
    }

    return {
      title: titleParsed,
      description: descriptionParsed,
    };
  },
};
